import React, { PureComponent, Fragment } from "react";
import { Router, Switch, Route } from "react-router-dom";
import { connect } from "react-redux";
import ReactGA from 'react-ga';
import createBrowserHistory from "history/createBrowserHistory";
import appRoutes from "./app-routes.js";
import AppNotifications from "./app-notifications.jsx";
import AppMessages from "./app-messages.jsx";
import PrivateRoute from "./utils/required-auth.js";
import withComponentWrapper from "./component-wrapper.jsx";
import * as Sentry from '@sentry/browser';
const hist = createBrowserHistory();

ReactGA.initialize('UA-134518490-2');

const GaPageView = () => {
  ReactGA.set({ page: window.location.pathname });
  ReactGA.pageview(window.location.pathname);
  return null;
}

class App extends PureComponent {
  render() {
    const { isAuthenticated } = this.props;
    return (
      <Fragment>
        <Router history={hist}>
          <>
            <Route path="/" component={GaPageView} />
            <Switch>
              {
                appRoutes.map((prop, key) => {
                  if (prop.isRequiredAuth) {
                    return <PrivateRoute
                      path={prop.path}
                      component={prop.component}
                      key={key}
                      isAuthenticated={isAuthenticated}
                    />
                  }
                  return <Route path={prop.path} component={prop.component} key={key} />;
                })
              }
            </Switch>
          </>
        </Router>
        <AppMessages />
        <AppNotifications />
      </Fragment >
    )
  }
}

const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.login.isAuthenticated
  }
}
export default connect(mapStateToProps, null)(withComponentWrapper(App));
